import { PictureDTO } from "../common/picture.dto";


export class teamMemberDTO {
  profilePicId: number;
  profilePicUrl:string;
  profilePic:PictureDTO = new PictureDTO();
  name:string;
  firstName: string;
  lastName: string;
  email: string;
  gender: string;
  dob: string;
  language: string;
  state: string;
  city: string;
  zipCode: string;
  password: string;
  status: string;
  defaultRole: string;
  roleId: number;
  currentRole: string;
  constructor(data: Partial<teamMemberDTO> = {}) {
    for (let key in data) {
      this[key] = data[key];
    }
  }
}
